module.exports = __webpack_public_path__ + "img/ma-bottom.2eb9426f.png";